







import Vue from "vue";
import {Util} from "@/util/util";

export default Vue.extend({
    name: "DomainItem",
    props: {
        language: {
            type: String,
            default: ""
        },
        languageDisplay: {
            type: String,
            default: ""
        }
    },
    methods: {
        getLanguageInUpperCase(): string {
            return this.language.toUpperCase();
        },

        getCapitalizedLanguageDisplay(): string {
            return this.languageDisplay[0].toUpperCase() + this.languageDisplay.slice(1);
        },

        getImageSource() {
            return `${Util.getConfig().resourcePath}/dist/img/flags/${this.language}.svg`
        },
    }
});
